import apiWorker from '../apiWorker'

const navbar = {
    getCounts: (user_id) => apiWorker('get',  `/api/v1/core/navbar/get_counts/${user_id}`, null, true),
}

export default navbar;